module.exports = __webpack_public_path__ + "static/media/slider-l5.dfe9e566.webp";